import React from "react";

const ICON = {
    width: "23",
    height: "23",
    colors: {
        candidate: "#00466e",
        company: "#94D63D"
    }
};


function IconPicture({ iconType }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={ICON.width} height={ICON.height}
      fill="none" viewBox="0 0 23 18"
    >
      <path
        fill={iconType === "candidate" ? ICON.colors.candidate : ICON.colors.company}
        d="M11.19 13.27a3.133 3.133 0 100-6.266 3.133 3.133 0 000 6.266z"
      ></path>
      <path
        fill={iconType === "candidate" ? ICON.colors.candidate : ICON.colors.company}
        d="M8.168 2.305h-6.21A1.964 1.964 0 000 4.263v11.748c0 1.077.881 1.958 1.958 1.958h18.461a1.964 1.964 0 001.958-1.958V4.263a1.964 1.964 0 00-1.958-1.958H8.168zm3.02 12.727a4.897 4.897 0 01-4.894-4.895 4.897 4.897 0 014.895-4.895 4.897 4.897 0 014.895 4.895 4.897 4.897 0 01-4.895 4.895zM6.534 1.634C6.534.73 7.265 0 8.167 0h6.535c.902 0 1.633.731 1.633 1.634H6.534z"
      ></path>
    </svg>
  );
}

export default IconPicture;